import type { ComponentProps } from 'react';
import type React from 'react';

import { Translate } from '@change-corgi/core-react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconOutlinedFlag } from '@change-corgi/design-system-legacy/icons';
import { buttonResetStyles } from '@change-corgi/design-system-legacy/reset';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { ReportAbuseLinkContainer as ReportAbuseLink } from '../../containers/ReportAbuseLink';

type Props = ComponentProps<typeof ReportAbuseLink>;

export const ReportAIIssueLink: React.FC<Props> = (props) => {
	return (
		<ReportAbuseLink {...props}>
			<button type="button" sx={{ ...buttonResetStyles, display: 'flex', alignItems: 'center', mb: 16 }}>
				<Icon icon={iconOutlinedFlag} size="m" color="typography-secondary" mr={5} />
				<Text sx={{ textDecoration: 'underline' }} color="typography-secondary" size="caption">
					<Translate value="fe.pages.decision_maker_show.ai_content.report_issue_label" />
				</Text>
			</button>
		</ReportAbuseLink>
	);
};
